"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("components");
var Bonbon_svg_1 = __importDefault(require("imgs/Bonbon.svg"));
var Home = function () { return (react_1.default.createElement("div", { className: "ai-center d-f dark3 flex-col py7" },
    react_1.default.createElement("img", { className: "ani4 hov-ani-rot w6", src: Bonbon_svg_1.default }),
    react_1.default.createElement("p", { className: "f8 fw7" }, "Bonbon"),
    react_1.default.createElement("p", { className: "f6" }, "Keep it simple, but powerful"),
    react_1.default.createElement("p", { className: "f6 fw7 mt7" }, "Installation"),
    react_1.default.createElement("p", { className: "f4 mt5" }, "Clone repo"),
    react_1.default.createElement(components_1.Snippet, null, "git clone https://github.com/estidlore/bonbon.git"),
    react_1.default.createElement("p", { className: "f4 mt5" }, "Install with npm"),
    react_1.default.createElement(components_1.Snippet, null, "npm i @estidlore/bonbon"),
    react_1.default.createElement("p", { className: "f4 mt5" }, "Install with yarn"),
    react_1.default.createElement(components_1.Snippet, null, "yarn add @estidlore/bonbon"),
    react_1.default.createElement("p", { className: "f6 fw7 mt7" }, "Import"),
    react_1.default.createElement("p", { className: "f4 mt5" }, "In your main file (i.e. src/index.js) write:"),
    react_1.default.createElement(components_1.Snippet, null, "import \"@estidlore/bonbon/dist/css/index.css\";\n\n      \"import \"@estidlore/bonbon/dist/css/animations.css\";"),
    react_1.default.createElement("p", { className: "f4 mt5" }, "or if you want to import the scss:"),
    react_1.default.createElement(components_1.Snippet, null, "import \"@estidlore/bonbon/scss/index.scss\";\n      \n      import \"@estidlore/bonbon/scss/animations.scss\";"))); };
exports.Home = Home;
